module.exports = __webpack_public_path__ + "static/media/flower.7fd30a8b.jpg";